import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Hooks"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "hooks"
    }}>{`Hooks`}</h1>
    <p>{`Theme UI includes hooks for changing the color mode state and for using the Theme UI context directly.`}</p>
    <Note mdxType="Note">
      <p>{`To learn more about how React Hooks work, please see the `}<a parentName="p" {...{
          "href": "https://reactjs.org/docs/hooks-intro.html"
        }}>{`official React docs`}</a>{`.`}</p>
    </Note>
    <h2 {...{
      "id": "usethemeui"
    }}><inlineCode parentName="h2">{`useThemeUI`}</inlineCode></h2>
    <p>{`To access the `}<inlineCode parentName="p">{`context`}</inlineCode>{` object directly in a component, use the `}<inlineCode parentName="p">{`useThemeUI`}</inlineCode>{` hook.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { useThemeUI } from 'theme-ui'

export default (props) => {
  const context = useThemeUI()
  const { theme, components, colorMode, setColorMode } = context

  return <pre>{JSON.stringify(theme, null, 2)}</pre>
}
`}</code></pre>
    <h2 {...{
      "id": "usecolormode"
    }}><inlineCode parentName="h2">{`useColorMode`}</inlineCode></h2>
    <p>{`To change the color mode state in your application, use the `}<inlineCode parentName="p">{`useColorMode`}</inlineCode>{` hook.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { useColorMode } from 'theme-ui'

export default (props) => {
  const [colorMode, setColorMode] = useColorMode()
  return (
    <button
      onClick={(e) => {
        setColorMode(colorMode === 'light' ? 'dark' : 'light')
      }}>
      Toggle {colorMode === 'light' ? 'Dark' : 'Light'}
    </button>
  )
}
`}</code></pre>
    <p>{`Learn more in the `}<a parentName="p" {...{
        "href": "/color-modes"
      }}>{`color modes docs`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      